import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import SmoothScroll from "components/SmoothScroll";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import Home from "pages/home";
import Contact from "pages/contact";
import Blog from "pages/blog";
import Portfolio from "pages/Portfolio";
import Services from "pages/Services";
import NotFound from "pages/NotFound";
import AboutPage from "pages/home/components/about-page";
import CareersPage from "pages/home/components/Careers";
import BlogDetail from "./pages/blog/BlogDetails";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <SmoothScroll />
        <Header />

        <RouterRoutes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/Services" element={<Services />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/Careers" element={<CareersPage />} />
        </RouterRoutes>

      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
  